import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/vip.png';
const _withScopeId = n => (_pushScopeId("data-v-598f3cb8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vip-icon",
  src: _imports_0,
  alt: "VIP"
}, null, -1));
const _hoisted_2 = {
  class: "vip-text font-13-regular"
};
const _hoisted_3 = {
  class: "vip-tag"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "high-light"
}, "AIPPT", -1));
const _hoisted_5 = {
  class: "tag-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "vip-container",
    onClick: $setup.handleVipClick
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, _toDisplayString($setup.vipText), 1), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($setup.isSlideVip || $setup.isSvip ? ' 海量风格' : ''), 1)])]);
}